import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateBehaviorTags } from "../services/update-behavior-tags";

export function useUpdateBehaviorTags() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ userId, tags }: { userId: string; tags: string[] }) =>
      updateBehaviorTags({ userId, tags }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["users"], exact: false });
      toast({
        title: "Success",
        description: "Behavior tags updated",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to update behavior tags",
        variant: "destructive",
      });
    },
  });
}

